import React from 'react'

import FileDownloadIcon from '@mui/icons-material/FileDownload';

import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';

import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';

const moment = require('moment-timezone');

export default function TRAFFIOTimesheetsFull() {
  // Initialize start and end dates
  const [startDate, setStartDate] = React.useState(getMondayOfLastWeek());
  const [endDate, setEndDate] = React.useState(getMondayAfterLastWeek());
  const [displayEndDate, setDisplayEndDate] = React.useState(getSundayOfLastWeek());
  const [selectedStartDate, setSelectedStartDate] = React.useState(getMondayOfLastWeek());
  const [selectedEndDate, setSelectedEndDate] = React.useState(getSundayOfLastWeek());
  const [dateError, setDateError] = React.useState("");

  function getMondayOfLastWeek() {
    let date = moment().tz("Australia/Sydney");
    date.subtract(((date.day() + 6) % 7) + 7, 'days');
    return date.format('YYYY-MM-DD');
  }

  function getMondayAfterLastWeek() {
    let date = moment().tz("Australia/Sydney");
    let daysToSubtract = date.day() === 0 ? 7 : date.day();
    date.subtract(daysToSubtract - 1, 'days'); // subtracting one less to get to Monday
    return date.format('YYYY-MM-DD');
  }

  function getSundayOfLastWeek() {
    let date = moment().tz("Australia/Sydney");
    let daysToSubtract = date.day() === 0 ? 7 : date.day();
    date.subtract(daysToSubtract, 'days');
    return date.format('YYYY-MM-DD');
  }

  function getDayOfWeek(dateString) {
    // Create a new Date object
    const date = new Date(dateString);

    // Days of the week array
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    // Return the day of the week
    return days[date.getDay()];
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
    const year = date.getFullYear();
    return day + '/' + month + '/' + year;
  }

  const [loading, setLoading] = React.useState(true);
  const [traffioData, setTraffioData] = React.useState([]);

  const getTraffioData = async (rangeStart = startDate, rangeEnd = endDate, rangeDisplayEnd = displayEndDate) => {
    try {
      setLoading(true);
      // https://ic360portalbackend.azurewebsites.net
      const response = await fetch(`https://ic360portalbackend.azurewebsites.net/api/traffio/timesheets/${rangeStart}/${rangeEnd}`);

      if (!response.ok) {
        throw new Error("Could not fetch");
      }

      const data = await response.json();

      setTraffioData(data);
      setStartDate(rangeStart);
      setEndDate(rangeEnd);
      setDisplayEndDate(rangeDisplayEnd);

      console.log(JSON.stringify(data))
    } catch (error) {
      console.error("Error getting timesheets", error)
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    getTraffioData()
  }, [])

  const validateNightShift = (startTime, endTime) => {
    const startHours = startTime.split(":")[0]

    if (parseInt(startHours) >= 18) {
      return true
    }

    return false
  }

  const handleExport = async () => {

    // 1. Creating headers
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Exported Data');
    const headers = ["Job Number", "Booking Status", "Client", "Client Address", "Date", "Booking Start", "Booking End", "Full Name", "Docket Break", "Docket Start", "Docket End", "Docket Total", "Ord", "1.5x", "2x", "Docket Travel", "Meal", "Docket Number", "Physical Docket", "Classification", "Vehicle Regos", "Total Vehicles"]
    // const headers = ["Booking Status", "Docket Number", "Job Number", "Date", "Client", "Client Address", "Booking Start", "Booking End", "Full Name", "Classification", "Docket Start", "Docket End", "Docket Total", "Ord", "1.5x", "2x", "Docket Break", "Docket Travel"];
    worksheet.columns = headers.map(header => ({ header, key: header, width: 15 }));

    // 1.1 Bolding Header Rows
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // 1.2 Centering the columns
    for (let i = 0; i < headers.length; i++) {
      worksheet.getColumn(`${headers[i]}`).alignment = { vertical: 'middle', horizontal: 'center' };
    }

    // 2. Aggregate data
    let aggregatedData = []
    traffioData.forEach(job => {
      job.workerInfo.forEach(workerDocket => {

        const dayOfWeek = getDayOfWeek(job['booking_start_time'].split(" ")[0])

        let totalHours = workerDocket['total_hours']
        let totalTimeAndAHalf = 0
        let totalDoubleTime = 0

        if (totalHours > 8) {
          totalTimeAndAHalf = totalHours - 8
        }

        if (totalTimeAndAHalf > 2) {
          totalDoubleTime = totalTimeAndAHalf - 2
          totalTimeAndAHalf = 2
        }

        let ordHours = totalHours - totalDoubleTime - totalTimeAndAHalf

        // SATURDAY HOURS
        if (dayOfWeek === "Saturday") {
          // Example: totalHours = 10, anything over 10 is double

          if (totalHours > 2) {
            totalTimeAndAHalf = 2
            totalDoubleTime = totalHours - 2
          }

          ordHours = 0
        }

        if (dayOfWeek === "Sunday") {
          ordHours = 0
          totalTimeAndAHalf = 0
          totalDoubleTime = totalHours
        }

        let newEntry = {
          "Booking Status": job['booking_status'],
          "Docket Number": job['works_docket_number'],
          "Job Number": job['job_number'],
          "Date": job['booking_start_time'].split(" ")[0],
          "Client": job['client_name'],
          "Client Address": job['works_docket_address'],
          "Booking Start": job['booking_start_time'].split(" ")[1],
          "Booking End": job['approx_booking_end_time'].split(" ")[1],
          "Full Name": workerDocket['first_name'] + ' ' + workerDocket['last_name'],
          "Classification": workerDocket['is_team_leader'] === "1" ? "TL" : "TC",
          "Docket Start": workerDocket['works_docket_time_on'].split(" ")[1],
          "Docket End": workerDocket['works_docket_time_off'].split(" ")[1],
          "Docket Total": workerDocket['total_hours'],
          "Ord": ordHours,
          "1.5x": totalTimeAndAHalf,
          "2x": totalDoubleTime,
          "Docket Break": workerDocket['works_docket_person_break_time'],
          "Docket Travel": workerDocket['works_docket_person_travel_time'],
          "Physical Docket": workerDocket["works_docket_physical_number"],
          "Meal": totalHours >= 9.5 ? 1 : 0,
          "Vehicle Regos": job['vehicle_regos'].join(' '),
          "Total Vehicles": job['vehicle_total']
        }
        aggregatedData.push(newEntry)
      })
    })

    // 2.1 Add data to the worksheet
    for (let i = 0; i < aggregatedData.length; i++) {
      worksheet.addRow(aggregatedData[i])
    }

    // 3 Styling
    // 3.1 Styling the classifications
    worksheet.eachRow((row, rowIndex) => {

      if (rowIndex === 1) {
        row.eachCell((cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFF7F67' }  // Tomato color for the entire header row
          };
        });
        return;
      }

      const classificationCell = row.getCell("Classification");
      if (classificationCell.value === 'TL') {
        classificationCell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFCCE5FF' } // Light Blue color
        };
      } else if (classificationCell.value === 'TC') {
        classificationCell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFF99' } // Light Yellow color
        };
      }

      const totalsCell = row.getCell("Docket Total")
      totalsCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFae9bd7' }
      }

      const ordCell = row.getCell("Ord")
      ordCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFC4D79B' }
      }

      const timeAndAHalfCell = row.getCell("1.5x")
      timeAndAHalfCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFC4D79B' }
      }

      const doubleTimeCell = row.getCell("2x")
      doubleTimeCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFC4D79B' }
      }

      const mealCell = row.getCell("Meal")
      if (mealCell.value === 1) {
        mealCell.fill = {
          type: 'pattern',
          pattern: "solid",
          fgColor: { argb: 'FFffc30b' }
        }
      }

      // Styling the colors of the start times and end times
      // Overnight shifts have a different rate
      const docketStartCell = row.getCell("Docket Start")
      const docketEndCell = row.getCell("Docket End")
      const rowNightShift = validateNightShift(docketStartCell.value, docketEndCell.value)

      if (rowNightShift === true) {
        docketStartCell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFD1D1" }
        }

        docketEndCell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFD1D1" }
        }
      }

      // Styling sunday and saturdays
      const docketDateCell = row.getCell("Date")
      const docketDateDay = getDayOfWeek(docketDateCell.value)

      if (docketDateDay === "Saturday" || docketDateDay === "Sunday") {
        docketDateCell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFD8C6FF" }
        }
      }
    });

    // Construct and return the new string
    const buffer = await workbook.xlsx.writeBuffer();
    const fileName = `Traffio Payables`;
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `${fileName}.xlsx`);
  }

  // For linear progress
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const handleRunReport = () => {
    if (!selectedStartDate || !selectedEndDate) {
      setDateError("Please select a start and end date.");
      return;
    }

    const start = moment(selectedStartDate);
    const end = moment(selectedEndDate);

    if (start.isAfter(end)) {
      setDateError("Start date must be on or before end date.");
      return;
    }

    // API expects the day after the display end date to capture the full final day.
    const apiEndDate = moment(end).add(1, "day").format("YYYY-MM-DD");

    setDateError("");
    getTraffioData(start.format("YYYY-MM-DD"), apiEndDate, end.format("YYYY-MM-DD"));
  }

  return (
    <>
      <div className="page-buttons-bar">
        <div className='page-buttons-bar-subtitle' style={{ paddingBottom: "1vh" }}>TRAFFIO</div>
      </div>
      <div className='timesheet-card' style={{ paddingBottom: "2vh" }}>
        <div className="timesheet-card-title">
          Week: <span className='timesheet-card-text-orange'>{formatDate(selectedStartDate || startDate)} - {formatDate(selectedEndDate || displayEndDate)}</span>
          <div style={{ display: "flex", gap: "10px", alignItems: "center", marginTop: "10px", marginBottom: "10px" }}>
            <label style={{ fontSize: "15px" }}>Start</label>
            <input style={{ fontSize: "15px" }} type="date" value={selectedStartDate} onChange={(e) => setSelectedStartDate(e.target.value)} />
            <label style={{ fontSize: "15px" }}>End</label>
            <input style={{ fontSize: "15px" }} type="date" value={selectedEndDate} onChange={(e) => setSelectedEndDate(e.target.value)} />
            <Button
              sx={{
                background: "#4CAF50",
                color: "white",
                border: "1px solid #4CAF50",
                "&:hover": {
                  background: "#43A047",
                  color: "white",
                }
              }}
              onClick={handleRunReport}
            >
              Run
            </Button>
            <Button
              disabled={loading}
              sx={{
                background: loading ? "#b0b0b0" : "#4CAF50",
                color: "white",
                border: "1px solid",
                borderColor: loading ? "#b0b0b0" : "#4CAF50",
                "&:hover": {
                  background: loading ? "#b0b0b0" : "#43A047",
                  color: "white",
                }
              }}
              onClick={handleExport}
            >
              <FileDownloadIcon sx={{ marginRight: "5px", fontSize: "1rem" }} /> Export
            </Button>
          </div>
          {dateError && <div style={{ color: "tomato", marginTop: "8px" }}>{dateError}</div>}
          <div>
            {
              loading &&
              <>
                <div>Creating Excel File...</div>
                <LinearProgress variant="determinate" value={progress}
                  sx={{
                    background: "black", marginRight: "1vw", marginTop: "1vh", marginBottom: "1vh",
                    '& .MuiLinearProgress-bar': {
                      backgroundColor: 'tomato',
                    },
                  }} />
              </>
            }
          </div>
        </div>
      </div>
    </>
  )
}
